import normalizeForComparison from "utils/normalizeForComparison";

/**
 * Accent- and case-insensitive search used to filter the select options.
 */
export function matchesSearch(label, search) {
    return normalizeForComparison(label).includes(normalizeForComparison(search));
}

/**
 * react-select injects the "create" entry among regular options; it must
 * always survive the filter, whatever the search input is.
 */
export function isCreateOptionCandidate(candidate) {
    return true === candidate.data?.__isNew__;
}

/**
 * The creation entry replaces "No options": it is proposed unless the typed
 * value is *exactly* an existing option (accent/case insensitive). A substring
 * match must not suppress it, otherwise a value that merely appears inside a
 * longer option (e.g. "bag" inside "bagages") could never be created.
 */
export function shouldProposeCreation(options, inputValue) {
    const normalizedInput = normalizeForComparison(inputValue);

    if ('' === normalizedInput) {
        return false;
    }

    return !options.some((option) => normalizeForComparison(option.label) === normalizedInput);
}
